import type { FC, ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import useAuth from '../hooks/useAuth';

interface GuestGuardProps {
  children: ReactNode;
}

const GuestGuard: FC<GuestGuardProps> = ({ children }) => {
  const { isAuthenticated } = useAuth();
  const is2FAEnabled = localStorage.getItem('is2FAEnabled') === 'true';
  const isOtpVerified = localStorage.getItem('isOtpVerified') === 'true';

  if (isAuthenticated) {
    return <Navigate to="/cases/dashboard" />;
  }

  if (is2FAEnabled && !isOtpVerified) {
    return <Navigate to="/login/two-factor-authentication" />;
  }

  return <>{children}</>;
};

GuestGuard.propTypes = {
  children: PropTypes.node,
};

export default GuestGuard;
